<template>
  <v-main>
    <GenericReport
      ref="report"
      orientation="horizontal"
      hide-header
      class="clean-list"
      :reportSpec="reportSpec"
      @rowClicked="selectRow"
    >
      <!-- Observe que não tem botão para criar novo centro de
       custo, porque queremos forçar que isto ocorra sempre
       a partir da tela de Clientes, o que garante que cada
       Centro de Custo esteja sempre associado a um Cliente. -->
    </GenericReport>
  </v-main>
</template>

<script>
import GenericReport from 'oderon-vue/cpts/generic-report/GenericReport.vue'
import { CostCenter } from '@/models'
import { saveBlobAs } from 'oderon-vue/utils'

export default {
  pageTitle: 'Centros de Custo',
  components: { GenericReport },
  data() {
    return {
      reportSpec: {
        code: 'costCenters',
        title: 'Centros de Custo',
        apiBase: '/cost-centers',
        filters: [
          {
            type: 'Text',
            prefix: 'keywords',
            icon: 'mdi-magnify',
            size: 'md',
            debounceMs: 250
          },
          {
            type: 'Switch',
            prefix: 'includeInactive',
            label: 'Mostrar inativos'
          }
        ]
      },

      menuOpts: [
        { text: 'Exportar Múltiplos...', onClick: () => this.exportMany() },
        { text: 'Exportar Esta Lista', onClick: () => this.download() }
      ]
    }
  },
  methods: {
    async download() {
      this.$loading(async () => {
        const ps = this.$refs.report.apiParams
        let { blob, filename } = await CostCenter.downloadGrid(ps)
        await saveBlobAs(blob, filename)
      })
    },

    async selectRow({ row, isMiddle }) {
      if (isMiddle) window.open(`/#/billing/cost-centers/${row.id}`, '_blank')
      else this.$router.push(`/billing/cost-centers/${row.id}`)
    },

    async exportMany() {
      let dialog = this.$refs.exportManyDialog
      await dialog.open()
    }
  }
}
</script>

<style></style>
